'use strict';Object.defineProperty(exports,'__esModule',{value:!0}),exports.default=function(value,destinationPosition){var formatValue=value,destination=destinationPosition;return'00'===formatValue.substr(0,2)&&(formatValue='0'),/[2-9]/g.test(formatValue[0])&&(formatValue='0'+formatValue[0],destination+=1),{value:formatValue,destination:destination}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/StringFunctions/formatDate.js
// module id = 772
// module chunks = 0